<template>
	<div class="stat-view">
		<div class="header">
			<h2>{{ conditionText }}</h2>
		</div>
		<div>
			<table class="table">
				<thead>
					<tr>
						<th v-for="(th, index) in table.columns" :key="index" v-text="th.text"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(tr, tr_index) in table.rows" :key="tr_index">
						<td v-for="(td, td_index) in tr.columns" :key="td_index" v-text="td.text"></td>
					</tr>
				</tbody>
			</table>
		</div>

		<!--统计图-->
		<div ref="res1">
			<div :class="{ charts: true, block: chartData.length == 1 }" v-for="(item, index) in chartData" :key="index">
				<ve-histogram v-if="chartType == 0 || item.columns.length > 10" :title="getTitle(item.title)" legend-position="bottom" :data="item"></ve-histogram>
				<ve-line v-else-if="chartType == 1" :title="getTitle(item.title)" legend-position="bottom" :data="item"></ve-line>
				<ve-pie v-else-if="chartType == 2" :title="getTitle(item.title)" legend-position="bottom" :data="item" :setting="pieChartSetting"></ve-pie>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			table: {
				type: Object,
			},
			chartType: {
				type: Number,
			},
			chartData: {
				type: Array,
				default() {
					return {}
				},
			},
			conditionText: {
				type: String,
			},
		},
		data() {
			this.typeArr = ['histogram', 'line', 'pie']
			return {
				pieChartSetting: {
					itemStyle: {
						normal: {
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)',
							},
							labelLine: { show: true },
						},
					},
				},
			}
		},
		watch: {
			// chartData(newVal, oldVal) {
			// 	if (document.createEvent) {
			// 		var event = document.createEvent('HTMLEvents')
			// 		event.initEvent('resize', true, true)
			// 		window.dispatchEvent(event)
			// 	} else if (document.createEventObject) {
			// 		window.fireEvent('onresize')
			// 	}
			// },
		},
		methods: {
			getTitle(title) {
				if (!title) return {}
				return {
					text: title,
					textAlign: 'left',
					textVerticalAlign: 'middle',
					x: 'center',
					y: 'top',
					top: '0',
					padding: [20, 0, 30, 0],
				}
			},
		},
		created() {},
	}
</script>

<style lang="less" scoped>
	.stat-view {
		margin: 50px auto 0;
	}
	.header {
		text-align: center;
		> h2 {
			line-height: 30px;
			font-size: 24px;
		}
	}

	.condition {
		border-bottom: 1px #333 solid;
		padding: 10px 20px;
		color: #aaa;
	}

	.table {
		width: 100%;
		border-collapse: collapse;
		border-left: 1px #333 solid;
		border-bottom: 1px #333 solid;

		td,
		th {
			padding: 5px 3px;
			border-right: 1px #333 solid;
			border-top: 1px #333 solid;
			font-size: 12px;
			text-align: center;
		}
	}

	.table-rise {
		margin-bottom: 20px;
	}

	.table-rise .label {
		font-weight: bold;
		text-align: right;
		padding: 15px 0 0 0;
	}

	.table-rise .subline {
		border-bottom: 2px #000 solid;
	}

	.charts {
		margin-top: 50px;
		width: 33.333%;
		float: left;
		height: 370px;
		margin-bottom: 50px;
	}

	.charts.block {
		width: 100%;
	}
</style>
